import * as queries from '../../../graphql/queries';
import { API, graphqlOperation } from 'aws-amplify';
import {
  setDqPdfDocument,
  setPdfError,
  setDQ,
  setQuestions,
  setError,
} from './viewDQFSlice';
import * as mutations from '../../../graphql/mutations';
import { createQuestions, updateDriverQualification } from '../../../graphql/customMutations';
import { getUser } from '../../../graphql/queries';
import { fetchPdfLinkUrl, fetchPdfObjectUrl, isPdfMissing } from '../../../utils/fetchPdfObjectUrl';

export const getDQByID = async (dispatch, id) => {
  try {
    const response = await API.graphql({
      query: queries.getDriverQualification,
      variables: { id: id },
    });
    if (response.data.getDriverQualification) {
      dispatch(setDQ(response.data.getDriverQualification));
    } else {
      dispatch(setError('Not Found'));
    }
  } catch (e) {
    console.log(e);
  }
};
export const getDQEmail = async id => {
  try {
    const response = await API.graphql({
      query: queries.getDriverQualification,
      variables: { id: id },
    });

    if (response.data.getDriverQualification) {
      return response.data.getDriverQualification?.dqClientApproverUser;
    }
  } catch (e) {
    console.log('get dq error', e);
  }
};

export const getPDF = async (dispatch, pdf, isCancelled = () => false, isMobile = false) => {
  try {
    // Mobile opens the document in its own tab, so give the anchor the presigned URL.
    // Desktop embeds it, which must be a blob so no second S3 request is made.
    const url = isMobile ? await fetchPdfLinkUrl(`dqf/${pdf}`) : await fetchPdfObjectUrl(`dqf/${pdf}`);
    if (isCancelled()) {
      if (!isMobile) URL.revokeObjectURL(url);
      return;
    }
    dispatch(setDqPdfDocument(url));
    dispatch(setPdfError(false));
  } catch (err) {
    if (isCancelled()) return;
    console.log('This is the error', err);
    dispatch(setPdfError(isPdfMissing(err) ? 'missing' : 'failed'));
  }
};

export const updateDQStatus = async (
  dispatch,
  id,
  status,
  clientId,
  clientApproverName,
) => {
  const update = {
    id: id,
    status: status.toString(),
    dqClientApproverUser: clientId,
    dqClientApproverUserFullName: clientApproverName,
  };
  try {
    await API.graphql(
      graphqlOperation(updateDriverQualification, {
        input: update,
      }),
    );

    // The mutation response can't carry locationState/locationCity or the connection lists
    // (see customMutations.js), so re-read the DQ to keep the view fully hydrated.
    await getDQByID(dispatch, id);

    return true;
  } catch (e) {
    console.log('Update Status Error:', e);
    return false;
  }
};

export const createQuestion = async (
  dispatch,
  id,
  createUser,
  text,
  clientApproverName,
  statusChange,
  dqOwnerFullName,
) => {
  const create = {
    driverQualificationQuestionsId: id,
    user: createUser,
    text: text,
    status: 'In-Progress',
    createUserFullName: clientApproverName
      ? clientApproverName
      : dqOwnerFullName,
    type: statusChange,
  };
  try {
    const response = await API.graphql(
      graphqlOperation(createQuestions, { input: create }),
    );
    dispatch(setQuestions(response.data.createQuestions));
    return true;
  } catch (e) {
    console.log('Update Status Error: ' + JSON.stringify(e));
    return false;
  }
};

export const generatePWToken = async (objectId, email) => {
  const data = {
    ApplicationId: '2',
    ObjectId: objectId,
    UserId: email,
    Event: 'GeneratePWToken',
  };
  try {
    const response = await API.graphql(
      graphqlOperation(mutations.createEvent, {
        input: data,
      }),
    );
    return true;
  } catch (e) {
    console.log('Update Status Error: ' + JSON.stringify(e));
    return false;
  }
};

export const fetchUser = async id => {
  try {
    const response = await API.graphql({
      query: getUser,
      variables: { id: id },
    });
    return response.data.getUser.name;
  } catch (e) {
    console.log(e);
  }
};

export const getUserInfo = async id => {
  try {
    const response = await API.graphql({
      query: getUser,
      variables: { id: id },
    });
    return response.data.getUser;
  } catch (e) {
    console.log(e);
  }
};
